import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import { captureException, createReduxEnhancer } from '@sentry/react';
import { configureStore } from '@reduxjs/toolkit';

import { rootReducer } from './root.reducer';
import { rootSaga } from '../sagas';
import paginationMiddleware from './middleware/paginationMiddleware';

const logger = createLogger({
    collapsed: true,
    duration: true,
});

const sentryReduxEnhancer = createReduxEnhancer();

const sagaMiddleware = createSagaMiddleware({
    onError: (error) => {
        console.error(error);
        captureException(error);
    },
});

const middleware = [sagaMiddleware, paginationMiddleware];

if (import.meta.env.DEV === true) {
    middleware.push(logger as any);
}

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(middleware),
    enhancers: [sentryReduxEnhancer],
});
sagaMiddleware.run(rootSaga);

export default store;

export type AppDispatch = typeof store.dispatch;
